import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import ForgottenContent from './ForgottenContent';

const customStyles = {
  overlay : {
    zIndex: 2000,
  },
  content : {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  }
};

class ForgottenModal extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  }

  static defaultProps = {
    isOpen: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      email: '',
    };
  }

  onSubmitContent = (e) => {
    e.preventDefault();
    
    const { 
        email,
      } = this.state;
    
    this.props.onSubmit({
      email,
    });
  }

  onChangeEmail = (e) =>
    this.setState({
      email: e.target.value
    });

  render() {
    const { 
        email,
      } = this.state;
    const {
        isOpen,
        onClose,
      } = this.props;

    return (
      <Modal
        style={customStyles}
        isOpen={isOpen}
        contentLabel="Email"
        onRequestClose={onClose}
      >
        <ForgottenContent 
          onSubmit={this.onSubmitContent}
          onChangeEmail={this.onChangeEmail}
          email={email}
        />
      </Modal>
    );
  }
};

export default ForgottenModal;



// WEBPACK FOOTER //
// ./src/components/ForgottenModal/ForgottenModal.jsx